<script lang="ts">
	import { cn } from '@ui-lib/utils/utils.js';
	import { Command as CommandPrimitive } from 'bits-ui';
	import ScrollArea from '../scroll-area/scroll-area.svelte';

	let {
		ref = $bindable(null),
		children,
		class: className,
		...restProps
	}: CommandPrimitive.ListProps = $props();
</script>

<CommandPrimitive.List class={cn('max-h-[300px]', className)} {...restProps} bind:ref>
	<ScrollArea class="h-full w-full" orientation="vertical">
		{@render children?.()}
	</ScrollArea>
</CommandPrimitive.List>
